import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Card, CardContent } from '@/components/ui/card';
import { SwitchField } from '@/modules/common/components/molecules/inputs/switch-field';

import {
  FORM_FIELD_ALLOW_HALF_DAY,
  FORM_FIELD_ALLOW_HOURLY_REQUESTS,
  FORM_FIELD_ALLOW_QUARTER_DAY,
} from '../../../../constants/time-off-type-form-fields';
import { TimeOffTypeSetupFormData } from '../../../../validations/time-off-type-validation';

interface PartialDayOptionsSectionProps {
  form: UseFormReturn<TimeOffTypeSetupFormData>;
  isReadMode: boolean;
}

export function PartialDayOptionsSection({ form, isReadMode }: PartialDayOptionsSectionProps) {
  const { t } = useTranslation('authenticated.settings');

  return (
    <Card>
      <CardContent className="space-y-4 p-6">
        <div>
          <h3 className="text-md font-semibold">
            {t('pages.timeOff.details.sections.partialDay.title')}
          </h3>
          <p className="mt-0.5 text-xs text-muted-foreground">
            {t('pages.timeOff.details.sections.partialDay.description')}
          </p>
        </div>

        <SwitchField
          name={FORM_FIELD_ALLOW_HALF_DAY}
          control={form.control}
          label={t('pages.timeOff.details.sections.partialDay.halfDay')}
          disabled={isReadMode}
        />

        <SwitchField
          name={FORM_FIELD_ALLOW_QUARTER_DAY}
          control={form.control}
          label={t('pages.timeOff.details.sections.partialDay.quarterDay')}
          disabled={isReadMode}
        />

        <SwitchField
          name={FORM_FIELD_ALLOW_HOURLY_REQUESTS}
          control={form.control}
          label={t('pages.timeOff.details.sections.partialDay.hourly')}
          disabled={isReadMode}
        />
      </CardContent>
    </Card>
  );
}
